<div class="page-title">
  <span>
    <span [translate]="'SDS_SUBST_TITLE'"></span>
  </span>
  <!-- Actions sit in the title row, matching the Exposure register page. -->
  <span class="page-actions sds-subst-actions">
    <!-- Substitution duty: produktkontrolloven § 3a. -->
    <app-sds-legal-reference reference="substitution"></app-sds-legal-reference>

    <button
      class="btn btn-primary btn-sm"
      type="button"
      [disabled]="!selected.length"
      (click)="assessSelected()"
    >
      <i class="pi pi-check-circle"></i>
      <span>{{ 'SDS_SUBST_ASSESS_SELECTED' | translate }} ({{ selected.length }})</span>
    </button>

    <!-- Same Export control as the Exposure register: one button, dropdown of formats. -->
    <button
      class="btn btn-outline-primary btn-sm sds-export-trigger"
      type="button"
      (click)="openExportMenu($event)"
      [disabled]="!canExport"
    >
      <i class="pi" [ngClass]="exportLoading ? 'pi-spin pi-spinner' : 'pi-download'"></i>
      <span [translate]="'EXPORT'"></span>
      <i class="pi pi-angle-down sds-export-caret"></i>
    </button>
    <p-menu
      #exportMenu
      [popup]="true"
      [model]="exportMenuItems"
      appendTo="body"
      styleClass="sds-actions-menu"
    ></p-menu>
  </span>
</div>

<div class="sds-subst sds-subst-page">
    <!-- Toolbar -->
    <div class="sds-subst-toolbar">
      <div class="sds-subst-toolbar-left">
        <p-iconfield class="sds-search-field">
          <p-inputicon styleClass="pi pi-search" />
          <input
            #substSearch
            pInputText
            type="text"
            [placeholder]="'SDS_SUBST_SEARCH' | translate"
            (input)="applyGlobalFilter(substSearch.value)"
          />
        </p-iconfield>

        <p-select
          [options]="statusOptions"
          [(ngModel)]="statusFilter"
          optionValue="value"
          (onChange)="onStatusChange()"
          [style]="{ minWidth: '170px' }"
        >
          <ng-template let-opt pTemplate="item">{{ opt.labelKey | translate }}</ng-template>
          <ng-template let-opt pTemplate="selectedItem">{{ opt.labelKey | translate }}</ng-template>
        </p-select>
      </div>
    </div>

    <!-- Grid -->
    <p-table
      #assessTable
      [value]="rows"
      dataKey="DocumentId"
      [(selection)]="selected"
      [loading]="loading"
      [rows]="12"
      [paginator]="true"
      [rowsPerPageOptions]="[12, 25, 50]"
      paginatorDropdownAppendTo="body"
      [globalFilterFields]="['Product', 'CASNumber', 'Supplier', 'Status']"
      styleClass="p-datatable-sm sds-subst-table sds-modern-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th pSortableColumn="Product">{{ 'SDS_PRODUCT_NAME' | translate }} <p-sortIcon field="Product"></p-sortIcon></th>
          <th>CAS</th>
          <th>{{ 'SDS_SUPPLIER' | translate }}</th>
          <th pSortableColumn="LastAssessmentDate">{{ 'SDS_SUBST_LAST_ASSESSED' | translate }} <p-sortIcon field="LastAssessmentDate"></p-sortIcon></th>
          <th>{{ 'SDS_SUBST_REMINDER' | translate }}</th>
          <th>{{ 'SDS_SUBST_STATUS' | translate }}</th>
          <th style="width: 110px; text-align: center">{{ 'ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr
          [class.sds-subst-overdue]="row.IsOverdue && !isRowAssessed(row)"
          [class.sds-subst-assessed]="isRowAssessed(row)"
        >
          <td>
            <p-tableCheckbox *ngIf="row.Status !== 'SoftDeleted'" [value]="row"></p-tableCheckbox>
          </td>
          <td>
            <span
              class="sds-product-link"
              (click)="openProductPreview(row)"
              [pTooltip]="'SDS_PREVIEW_PDF' | translate"
              tooltipPosition="top"
            >
              {{ row.Product }}
              <i class="pi pi-eye sds-view-icon"></i>
            </span>
          </td>
          <td>
            <!-- A data sheet can list 20+ CAS numbers; clamp the cell so the
                 column cannot squeeze the rest of the grid, full list on hover. -->
            <span class="sds-cas-cell" [pTooltip]="row.CASNumber" tooltipPosition="top">
              {{ row.CASNumber || '—' }}
            </span>
          </td>
          <td>{{ row.Supplier || '—' }}</td>
          <td>
            <span [class.sds-subst-overdue-text]="row.IsOverdue">
              {{ row.LastAssessmentDate ? (row.LastAssessmentDate | date:'dd/MM/yyyy') : ('SDS_SUBST_NEVER' | translate) }}
            </span>
          </td>
          <td>{{ row.ReminderDate ? (row.ReminderDate | date:'dd/MM/yyyy') : '—' }}</td>
          <td>
            <span class="sds-subst-status" [attr.data-status]="row.Status">
              {{ ('SDS_SUBST_STATUS_' + row.Status.toUpperCase()) | translate }}
            </span>
          </td>
          <td style="text-align: center">
            <div class="sds-subst-row-actions">
              <button
                *ngIf="row.Status !== 'SoftDeleted'"
                class="btn btn-icon sds-subst-assess-btn"
                type="button"
                [pTooltip]="'SDS_SUBST_ASSESS_NOW' | translate"
                tooltipPosition="left"
                (click)="assessOne(row)"
              >
                <i class="pi pi-check-circle"></i>
              </button>
              <button
                *ngIf="row.LastNote"
                class="btn btn-icon sds-subst-note-btn"
                type="button"
                [pTooltip]="'SDS_SUBST_VIEW_NOTE' | translate"
                tooltipPosition="left"
                (click)="viewNote(row)"
              >
                <i class="pi pi-info-circle"></i>
              </button>
              <button
                *ngIf="row.Status === 'Active'"
                class="btn btn-icon sds-subst-replace-btn"
                type="button"
                [pTooltip]="'SDS_SUBST_REPLACE' | translate"
                tooltipPosition="left"
                (click)="replace(row)"
              >
                <i class="pi pi-replay"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="sds-subst-empty">
            <i class="pi pi-inbox"></i>
            <span [translate]="'SDS_SUBST_EMPTY'"></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

<!-- ═══════════ ASSESS POPUP ═══════════ -->
<p-dialog
  [header]="'SDS_SUBST_ASSESS_TITLE' | translate"
  [(visible)]="assessDialogVisible"
  [style]="{ width: '460px', maxWidth: '94vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!assessDialogSaving"
  [baseZIndex]="11000"
>
  <div class="sds-subst-assess-body">
    <p class="sds-subst-assess-hint">
      {{ (pendingCount > 1 ? 'SDS_SUBST_ASSESS_HINT_MANY' : 'SDS_SUBST_ASSESS_HINT_ONE') | translate:{ count: pendingCount } }}
    </p>

    <div class="sds-subst-field">
      <label class="sds-field-label">{{ 'SDS_SUBST_ASSESSMENT_DATE' | translate }} <span class="sds-required-marker">*</span></label>
      <p-datepicker [(ngModel)]="assessmentDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
    </div>

    <div class="sds-subst-field">
      <label class="sds-field-label">{{ 'SDS_SUBST_REMINDER_DATE' | translate }}</label>
      <p-datepicker [(ngModel)]="reminderDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
      <small class="sds-field-hint" [translate]="'SDS_SUBST_REMINDER_HELP'"></small>
    </div>

    <div class="sds-subst-field">
      <label class="sds-field-label">{{ 'SDS_SUBST_NOTE' | translate }}</label>
      <textarea pTextarea [(ngModel)]="assessNote" rows="3" maxlength="1000" [style]="{ width: '100%' }"></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" type="button" (click)="assessDialogVisible = false" [disabled]="assessDialogSaving">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button class="btn btn-primary" type="button" (click)="confirmAssess()" [disabled]="assessDialogSaving || !assessmentDate">
      <i *ngIf="assessDialogSaving" class="pi pi-spin pi-spinner"></i>
      <span [translate]="'SAVE'"></span>
    </button>
  </ng-template>
</p-dialog>

<!-- ═══════════ ASSESSMENT NOTE POPUP ═══════════ -->
<p-dialog
  [header]="'SDS_SUBST_VIEW_NOTE' | translate"
  [(visible)]="notePopupVisible"
  [style]="{ width: '420px', maxWidth: '94vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="11000"
>
  <div class="sds-subst-note-popup">
    <div class="sds-subst-note-popup-product">{{ notePopupProduct }}</div>
    <p class="sds-subst-note-popup-text">{{ notePopupText }}</p>
  </div>
</p-dialog>

<!-- ═══════════ REPLACE MODAL (existing vs new) ═══════════ -->
<p-dialog
  [header]="'SDS_SUBST_REPLACE_TITLE' | translate"
  [(visible)]="replaceModalVisible"
  [style]="{ width: '520px', maxWidth: '94vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!replaceSaving"
  [baseZIndex]="11000"
  (onHide)="closeReplaceModal()"
>
  <!-- Step 1: choose how to replace -->
  <div class="sds-subst-replace-choice" *ngIf="replaceStep === 'choice'">
    <p class="sds-subst-replace-hint">
      {{ 'SDS_SUBST_REPLACE_CONFIRM' | translate:{ product: replaceTarget?.Product } }}
    </p>
    <div class="sds-subst-replace-options">
      <button class="btn btn-outline-primary" type="button" (click)="chooseReplaceExisting()">
        <i class="pi pi-search"></i>
        <span [translate]="'SDS_REPLACEMENT_USE_EXISTING'"></span>
      </button>
      <button class="btn btn-outline-primary" type="button" (click)="chooseReplaceNew()">
        <i class="pi pi-plus"></i>
        <span [translate]="'SDS_REPLACEMENT_CREATE_NEW'"></span>
      </button>
    </div>
  </div>

  <!-- Step 2: pick an existing chemical -->
  <div class="sds-subst-replace-existing" *ngIf="replaceStep === 'existing'">
    <p class="sds-subst-replace-hint" [translate]="'SDS_REPLACEMENT_USE_EXISTING_HINT'"></p>

    <div class="sds-subst-field">
      <label class="sds-field-label">
        {{ 'SDS_REPLACEMENT_SELECT_LABEL' | translate }}
        <span class="sds-required-marker">*</span>
      </label>
      <p-autoComplete
        [(ngModel)]="selectedReplacementCandidate"
        [suggestions]="replaceCandidateSuggestions"
        (completeMethod)="searchReplaceCandidates($event)"
        [forceSelection]="true"
        [minLength]="1"
        [delay]="200"
        appendTo="body"
        optionLabel="Product"
        dataKey="DocumentId"
        [placeholder]="'SDS_REPLACEMENT_SEARCH_PLACEHOLDER' | translate"
        [disabled]="replaceSaving"
        [style]="{ width: '100%' }"
      >
        <ng-template let-candidate pTemplate="item">
          <div>
            <strong>{{ candidate.Product }}</strong>
            <small *ngIf="candidate.CASNumber"> · {{ candidate.CASNumber }}</small>
            <small *ngIf="candidate.Supplier"> · {{ candidate.Supplier }}</small>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="sds-subst-field">
      <label class="sds-field-label">
        {{ 'SDS_REPLACEMENT_REASON_LABEL' | translate }}
        <small class="sds-field-optional" [translate]="'OPTIONAL'"></small>
      </label>
      <textarea
        pTextarea
        rows="3"
        maxlength="1000"
        [(ngModel)]="replaceReason"
        [disabled]="replaceSaving"
        [placeholder]="'SDS_REPLACEMENT_REASON_PLACEHOLDER' | translate"
        (input)="replaceError = null"
        [style]="{ width: '100%' }"
      ></textarea>
    </div>

    <div class="sds-subst-replace-error" *ngIf="replaceError">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ replaceError }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" type="button" (click)="closeReplaceModal()" [disabled]="replaceSaving">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button
      *ngIf="replaceStep === 'existing'"
      class="btn btn-primary"
      type="button"
      (click)="confirmReplaceExisting()"
      [disabled]="replaceSaving || !selectedReplacementCandidate"
    >
      <i class="pi" [ngClass]="replaceSaving ? 'pi-spin pi-spinner' : 'pi-sync'"></i>
      <span [translate]="'SDS_REPLACEMENT_CONFIRM'"></span>
    </button>
  </ng-template>
</p-dialog>

<!-- ═══════════ PDF PREVIEW SIDE-PANEL ═══════════ -->
<p-dialog
  [(visible)]="previewVisible"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: 'min(680px, 100vw)', height: '100dvh', maxHeight: '100dvh', margin: '0' }"
  [header]="previewProduct"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeProductPreview()"
  styleClass="sds-subst-preview-panel"
>
  <div class="sds-subst-preview-body">
    <div class="sds-subst-preview-state" *ngIf="previewLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <span [translate]="'PROCESSING'"></span>
    </div>
    <iframe
      *ngIf="!previewLoading && previewUrl"
      [src]="previewUrl"
      class="sds-subst-preview-iframe"
      frameborder="0"
    ></iframe>
    <div class="sds-subst-preview-state" *ngIf="!previewLoading && !previewUrl">
      <i class="pi pi-exclamation-triangle"></i>
      <span [translate]="'SDS_PDF_NOT_AVAILABLE'"></span>
    </div>
  </div>
</p-dialog>


